import { mapApproverDelegatee } from '@webapp/core/data-access/mappers/mapApproverDelegatee'
import { type RequestableApproverOptionConstructor } from '@webapp/modules/expense/entities/RequestableApproverOption'
import { type RequestableApproverOptionApiModel } from '../api-models/RequestableApproverOptionApiModel'

export const mapRequestableApproverOptionApiModel = (
  data: RequestableApproverOptionApiModel
): RequestableApproverOptionConstructor => ({
  id: data.id,
  userId: data.user_id,
  firstName: data.user.firstName,
  lastName: data.user.lastName,
  levelText: data.level_text ?? null,
  groupName: data.group?.name ?? null,
  approvalDelegatee: data.user.approval_delegatee
    ? mapApproverDelegatee(data.user.approval_delegatee)
    : null,
})
